"use client";
import * as w from "react";
import { a as ee } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { u as ne, T as ie } from "./useTimeout-BRUciAq6.mjs";
import { u as K } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as Q } from "./useEventCallback-CjuAhyNz.mjs";
import { u as oe } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as ue, a as ce } from "./FloatingTree-vWe5pGqE.mjs";
import { c as fe } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { f as U, c as Z, g as le } from "./element-DE7VsBMX.mjs";
import { i as te } from "./event-CXjJudzK.mjs";
import { g as ae } from "./nodes-C8EyMHS3.mjs";
const re = fe("safe-polygon");
function $(f, e, d) {
  if (d && !te(d))
    return 0;
  if (typeof f == "number")
    return f;
  if (typeof f == "function") {
    const l = f();
    return typeof l == "number" ? l : l == null ? void 0 : l[e];
  }
  return f == null ? void 0 : f[e];
}
function x(f) {
  return typeof f == "function" ? f() : f;
}
function Me(f, e = {}) {
  const {
    open: d,
    onOpenChange: l,
    dataRef: h,
    events: k,
    elements: c
  } = f, {
    enabled: m = !0,
    delay: D = 0,
    handleClose: B = null,
    mouseOnly: X = !1,
    restMs: P = 0,
    move: M = !0
  } = e, T = ue(), y = ce(), b = K(B), I = K(D), S = K(d), _ = K(P), E = w.useRef(void 0), g = ne(), j = w.useRef(void 0), C = ne(), J = w.useRef(!0), V = w.useRef(!1), A = w.useRef(() => {
  }), H = w.useRef(!1), q = Q(() => {
    var o;
    const r = (o = h.current.openEvent) == null ? void 0 : o.type;
    return (r == null ? void 0 : r.includes("mouse")) && r !== "mousedown";
  });
  w.useEffect(() => {
    if (!m)
      return;
    function r({
      open: o
    }) {
      o || (g.clear(), C.clear(), J.current = !0, H.current = !1);
    }
    return k.on("openchange", r), () => {
      k.off("openchange", r);
    };
  }, [m, k, g, C]), w.useEffect(() => {
    if (!m || !b.current || !d)
      return;
    function r(i) {
      q() && l(!1, i, "hover");
    }
    const o = U(c.floating).documentElement;
    return o.addEventListener("mouseleave", r), () => {
      o.removeEventListener("mouseleave", r);
    };
  }, [c.floating, d, l, m, b, q]);
  const s = w.useCallback((r, o = !0, i = "hover") => {
    const p = $(I.current, "close", E.current);
    p && !j.current ? g.start(p, () => l(!1, r, i)) : o && (g.clear(), l(!1, r, i));
  }, [I, l, g]), t = Q(() => {
    A.current(), j.current = void 0;
  }), R = Q(() => {
    if (V.current) {
      const r = U(c.floating).body;
      r.style.pointerEvents = "", r.removeAttribute(re), V.current = !1;
    }
  }), L = Q(() => h.current.openEvent ? ["click", "mousedown"].includes(h.current.openEvent.type) : !1);
  w.useEffect(() => {
    if (!m)
      return;
    function r(n) {
      if (g.clear(), J.current = !1, X && !te(E.current) || x(_.current) > 0 && !$(I.current, "open"))
        return;
      const u = $(I.current, "open", E.current);
      u ? g.start(u, () => {
        S.current || l(!0, n, "hover");
      }) : d || l(!0, n, "hover");
    }
    function o(n) {
      if (L()) {
        R();
        return;
      }
      A.current();
      const u = U(c.floating);
      if (C.clear(), H.current = !1, b.current && h.current.floatingContext) {
        d || g.clear(), j.current = b.current({
          ...h.current.floatingContext,
          tree: T,
          x: n.clientX,
          y: n.clientY,
          onClose() {
            R(), t(), L() || s(n, !0, "safe-polygon");
          }
        });
        const z = j.current;
        u.addEventListener("mousemove", z), A.current = () => {
          u.removeEventListener("mousemove", z);
        };
        return;
      }
      (E.current === "touch" ? !Z(c.floating, n.relatedTarget) : !0) && s(n);
    }
    function i(n) {
      var u;
      L() || h.current.floatingContext && ((u = b.current) == null || u.call(b, {
        ...h.current.floatingContext,
        tree: T,
        x: n.clientX,
        y: n.clientY,
        onClose() {
          R(), t(), L() || s(n);
        }
      })(n));
    }
    function p() {
      g.clear();
    }
    function F(n) {
      L() || s(n, !1);
    }
    if (ee(c.domReference)) {
      const n = c.domReference, u = c.floating;
      return d && n.addEventListener("mouseleave", i), M && n.addEventListener("mousemove", r, {
        once: !0
      }), n.addEventListener("mouseenter", r), n.addEventListener("mouseleave", o), u && (u.addEventListener("mouseleave", i), u.addEventListener("mouseenter", p), u.addEventListener("mouseleave", F)), () => {
        d && n.removeEventListener("mouseleave", i), M && n.removeEventListener("mousemove", r), n.removeEventListener("mouseenter", r), n.removeEventListener("mouseleave", o), u && (u.removeEventListener("mouseleave", i), u.removeEventListener("mouseenter", p), u.removeEventListener("mouseleave", F));
      };
    }
  }, [c, m, f, X, M, s, t, R, l, d, S, T, I, b, h, L, _, g, C]), oe(() => {
    var r, o, i, p;
    if (m && d && (o = (r = b.current) == null ? void 0 : r.__options) != null && o.blockPointerEvents && q()) {
      V.current = !0;
      const F = c.floating;
      if (ee(c.domReference) && F) {
        const n = U(c.floating).body;
        n.setAttribute(re, "");
        const u = c.domReference, Y = (p = (i = T == null ? void 0 : T.nodesRef.current.find((z) => z.id === y)) == null ? void 0 : i.context) == null ? void 0 : p.elements.floating;
        return Y && (Y.style.pointerEvents = ""), n.style.pointerEvents = "none", u.style.pointerEvents = "auto", F.style.pointerEvents = "auto", () => {
          n.style.pointerEvents = "", u.style.pointerEvents = "", F.style.pointerEvents = "";
        };
      }
    }
  }, [m, d, y, c, T, b, q]), oe(() => {
    d || (E.current = void 0, H.current = !1, t(), R());
  }, [d, t, R]), w.useEffect(() => () => {
    t(), g.clear(), C.clear(), R();
  }, [m, c.domReference, t, R, g, C]);
  const O = w.useMemo(() => {
    function r(o) {
      E.current = o.pointerType;
    }
    return {
      onPointerDown: r,
      onPointerEnter: r,
      onMouseMove(o) {
        const {
          nativeEvent: i
        } = o;
        function p() {
          !J.current && !S.current && l(!0, i, "hover");
        }
        X && !te(E.current) || d || x(_.current) === 0 || H.current && o.movementX ** 2 + o.movementY ** 2 < 2 || (C.clear(), E.current === "touch" ? p() : (H.current = !0, C.start(x(_.current), p)));
      }
    };
  }, [X, l, d, S, _, C]);
  return w.useMemo(() => m ? {
    reference: O
  } : {}, [m, O]);
}
function se(f, e) {
  const [d, l] = f;
  let h = !1;
  const k = e.length;
  for (let c = 0, m = k - 1; c < k; m = c++) {
    const [D, B] = e[c] || [0, 0], [X, P] = e[m] || [0, 0];
    B >= l != P >= l && d <= (X - D) * (l - B) / (P - B) + D && (h = !h);
  }
  return h;
}
function de(f, e) {
  return f[0] >= e.x && f[0] <= e.x + e.width && f[1] >= e.y && f[1] <= e.y + e.height;
}
function Te(f = {}) {
  const {
    buffer: e = 0.5,
    blockPointerEvents: d = !1,
    requireIntent: l = !0
  } = f, h = new ie();
  let k = !1, c = null, m = null, D = typeof performance < "u" ? performance.now() : 0;
  function B(P, M) {
    const T = performance.now(), y = T - D;
    if (c === null || m === null || y === 0)
      return c = P, m = M, D = T, null;
    const b = P - c, I = M - m, _ = Math.sqrt(b * b + I * I) / y;
    return c = P, m = M, D = T, _;
  }
  const X = ({
    x: P,
    y: M,
    placement: T,
    elements: y,
    onClose: b,
    nodeId: I,
    tree: S
  }) => function(E) {
    function g() {
      h.clear(), b();
    }
    if (h.clear(), !y.domReference || !y.floating || T == null || P == null || M == null)
      return;
    const {
      clientX: j,
      clientY: C
    } = E, J = [j, C], V = le(E), A = E.type === "mouseleave", H = Z(y.floating, V), q = Z(y.domReference, V), s = y.domReference.getBoundingClientRect(), t = y.floating.getBoundingClientRect(), R = T.split("-")[0], L = P > t.right - t.width / 2, O = M > t.bottom - t.height / 2, r = de(J, s), o = t.width > s.width, i = t.height > s.height, p = (o ? s : t).left, F = (o ? s : t).right, n = (i ? s : t).top, u = (i ? s : t).bottom;
    if (H && (k = !0, !A))
      return;
    if (q && (k = !1), q && !A) {
      k = !0;
      return;
    }
    if (A && ee(E.relatedTarget) && Z(y.floating, E.relatedTarget) || S && ae(S.nodesRef.current, I).some(({
      context: a
    }) => a == null ? void 0 : a.open))
      return;
    if (R === "top" && M >= s.bottom - 1 || R === "bottom" && M <= s.top + 1 || R === "left" && P >= s.right - 1 || R === "right" && P <= s.left + 1)
      return g();
    let Y = [];
    switch (R) {
      case "top":
        Y = [[p, s.top + 1], [p, t.bottom - 1], [F, t.bottom - 1], [F, s.top + 1]];
        break;
      case "bottom":
        Y = [[p, t.top + 1], [p, s.bottom - 1], [F, s.bottom - 1], [F, t.top + 1]];
        break;
      case "left":
        Y = [[t.right - 1, u], [t.right - 1, n], [s.left + 1, n], [s.left + 1, u]];
        break;
      case "right":
        Y = [[s.right - 1, u], [s.right - 1, n], [t.left + 1, n], [t.left + 1, u]];
        break;
    }
    function z([a, v]) {
      switch (R) {
        case "top": {
          const N = [o ? a + e / 2 : L ? a + e * 4 : a - e * 4, v + e + 1], W = [o ? a - e / 2 : L ? a + e * 4 : a - e * 4, v + e + 1], G = [[t.left, L || o ? t.bottom - e : t.top], [t.right, L ? o ? t.bottom - e : t.top : t.bottom - e]];
          return [N, W, ...G];
        }
        case "bottom": {
          const N = [o ? a + e / 2 : L ? a + e * 4 : a - e * 4, v - e], W = [o ? a - e / 2 : L ? a + e * 4 : a - e * 4, v - e], G = [[t.left, L || o ? t.top + e : t.bottom], [t.right, L ? o ? t.top + e : t.bottom : t.top + e]];
          return [N, W, ...G];
        }
        case "left": {
          const N = [a + e + 1, i ? v + e / 2 : O ? v + e * 4 : v - e * 4], W = [a + e + 1, i ? v - e / 2 : O ? v + e * 4 : v - e * 4];
          return [...[[O || i ? t.right - e : t.left, t.top], [O ? i ? t.right - e : t.left : t.right - e, t.bottom]], N, W];
        }
        case "right": {
          const N = [a - e, i ? v + e / 2 : O ? v + e * 4 : v - e * 4], W = [a - e, i ? v - e / 2 : O ? v + e * 4 : v - e * 4], G = [[O || i ? t.left + e : t.right, t.top], [O ? i ? t.left + e : t.right : t.left + e, t.bottom]];
          return [N, W, ...G];
        }
        default:
          return [];
      }
    }
    if (!se([j, C], Y)) {
      if (k && !r)
        return g();
      if (!A && l) {
        const a = B(E.clientX, E.clientY);
        if (a !== null && a < 0.1)
          return g();
      }
      se([j, C], z([P, M])) ? !k && l && h.start(40, g) : g();
    }
  };
  return X.__options = {
    blockPointerEvents: d
  }, X;
}
export {
  Te as s,
  Me as u
};
